/** Projects scene positions to pixels. out[3k+2] is clip w; <= 0 means behind the camera. */
export function projectAll(
  positions: Float32Array,
  count: number,
  m: ArrayLike<number>,
  width: number,
  height: number,
  out: Float32Array,
): void {
  for (let k = 0; k < count; k++) {
    const o = 3 * k;
    const x = positions[o],
      y = positions[o + 1],
      z = positions[o + 2];
    const cx = m[0] * x + m[4] * y + m[8] * z + m[12];
    const cy = m[1] * x + m[5] * y + m[9] * z + m[13];
    const cw = m[3] * x + m[7] * y + m[11] * z + m[15];
    if (cw <= 0) {
      out[o] = -1e9;
      out[o + 1] = -1e9;
      out[o + 2] = cw;
      continue;
    }
    out[o] = ((cx / cw) * 0.5 + 0.5) * width;
    out[o + 1] = (1 - ((cy / cw) * 0.5 + 0.5)) * height;
    out[o + 2] = cw;
  }
}

/** On-screen radius in pixels for each body, using clip w as the view depth. */
export function projectRadii(
  radii: Float32Array,
  screen: Float32Array,
  count: number,
  height: number,
  fovRad: number,
  out: Float32Array,
): void {
  const pixelsPerUnitAtOne = height / 2 / Math.tan(fovRad / 2);
  for (let k = 0; k < count; k++) {
    const w = screen[3 * k + 2];
    out[k] = w > 0 ? (radii[k] / w) * pixelsPerUnitAtOne : 0;
  }
}
